// extracted by mini-css-extract-plugin
export default {"title":"styles-module__title__src-labstep-web-core-Modal-Wizard-Header-_I5MVB","header":"styles-module__header__src-labstep-web-core-Modal-Wizard-Header-_kdvr0"};